import { Box, Typography, CardContent, Card, Grid } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';

const RoleDetails = () => {
  const location = useLocation();
  const { role } = location.state || {};

  if (!role)
    return (
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box sx={{ padding: 4 }}>
            <Typography>No role selected</Typography>
          </Box>
        </CardContent>
      </Card>
    );

  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: 4,
              paddingTop: 2,
              paddingBottom: 0,
            }}
          >
            <Typography variant="h5" gutterBottom>
              Admin: {role.role_name}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box sx={{ padding: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  First Name:
                </Typography>
                <Typography variant="body1">
                  {role.role_name.split(' ')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Last Name:
                </Typography>
                <Typography variant="body1">
                  {role.role_name.split(' ').slice(-1)}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Description
                </Typography>
                <Typography variant="body1">{role.description}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Permissions
                </Typography>
                <Typography variant="body1">
                  {role.permissions
                    .filter((perm) => perm.read || perm.write || perm.delete)
                    .map((perm, i) => (
                      <div key={i}>
                        <strong>{perm.asset}:</strong> {perm.read && 'Read '}
                        {perm.write && 'Write '}
                        {perm.delete && 'Delete'}
                      </div>
                    ))}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default RoleDetails;
